module.exports = __webpack_public_path__ + "img/4.c32079b6.png";